import React from 'react'
import { useMediaQuery } from 'react-responsive'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './desktop/pages/Home'
import HomeMobile from './mobile/pages/Home'
import Payment from './desktop/pages/Payment'
import PaymentResult from './desktop/pages/PaymentResult'
// import PaymentError from './desktop/pages/PaymentError'
import PaymentMobile from './mobile/pages/Payment'
import PaymentResultMobile from './mobile/pages/PaymentResult'
// import PaymentErrorMobile from './mobile/pages/PaymentError'
// import Promo from './desktop/pages/Promo'
// import PromoMobile from './mobile/pages/Promo'
import CheckticketMobile from './mobile/pages/Checkticket'
import { AuthProvider, RequireAuth, getObjectDisplay } from 'fennec-ui'
import { Provider, useDispatch } from 'react-redux';
import configureStore from './store/configureStore';
import { ConfigProvider } from 'antd';
import TgDesktop from './desktop/pages/Tg';
import TgMobile from './mobile/pages/Tg';
import EventResultMobile from './mobile/pages/EventResult'
import EventResult from './desktop/pages/EventResult'
import EventResultFinal from './desktop/pages/EventResultFinal'
import EventResultFinalMobile from './mobile/pages/EventResultFinal'
import { DeviceUUID } from "device-uuid"
import { IsDesktopOrLaptopContext, IsMobileContext, LayoutWidthContext } from './common/Context'
import { ClipboardContext, FieldFullReplacementProvider, FieldPartialReplacementProvider, ModelPartialReplacementProvider, ModelFullReplacementProvider, CollectionPartialReplacementProvider, CollectionFullReplacementProvider } from 'fennec-ui'
import { useState } from 'react'
import Reports from './desktop/pages/Reports'

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import Error404, { Error404Element } from './desktop/components/Error404'
import AppSwitch from './desktop/pages/AppSwitch'
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

const store = configureStore();

ConfigProvider.config({
	theme: {
		primaryColor: '#f6224b',
	},
});

// https://kamranicus.com/posts/2018-07-26-react-router-custom-transition-ui
const getUserConfirmation = (message, callback) => {
	console.log(message);
	callback(false);
}

function Layout(props) {
	const [clipboard, setClipboard] = useState({})
	const [layoutWidth, setLayoutWidth] = useState("1140px")
	let isMobile = false;
	try {
		isMobile = new DeviceUUID().parse()?.isMobile
	} catch (error) {
		console.error(error)
	}

	const isDesktopOrLaptop = useMediaQuery({ minWidth: 1224 })

	// const isBigScreen = useMediaQuery({ minDeviceWidth: 1824 })
	// const isTabletOrMobile = useMediaQuery({ maxWidth: 1224 })
	// const isTabletOrMobileDevice = useMediaQuery({ maxDeviceWidth: 1224 })
	// const isPortrait = useMediaQuery({ orientation: 'portrait' })
	// const isRetina = useMediaQuery({ minResolution: '2dppx' })

	const dispatch = useDispatch();
	fetch('/papi/fed/site-access').then(res => res.json()).then(({ data }) => {
		dispatch({ type: "SITE_ACCESS", payload: data });
	}).catch(() => console.log("Ошибка вызова /site-access"));

	const ComponetsReplacement = (props) => {
		console.log(props);
		return (<div>
			<div>{props?.item?.name}</div>
			<div>!!!!!!!!!!</div>
		</div>)
	}

	if (isDesktopOrLaptop || !isMobile) {
		return (
			<ClipboardContext.Provider value={[clipboard, setClipboard]}>
				<IsMobileContext.Provider value={isMobile}>
					<IsDesktopOrLaptopContext.Provider value={isDesktopOrLaptop}>
						<LayoutWidthContext.Provider value={[layoutWidth, setLayoutWidth]}>
							<CollectionFullReplacementProvider initial={{ "___VoprosiSudeiskikhAttestatsii": ComponetsReplacement }}>
								<CollectionPartialReplacementProvider initial={{ "___TrekiVPleiListakh": ComponetsReplacement }}>
									<ModelFullReplacementProvider initial={{ "___KategoriiVoprosov": ComponetsReplacement }}>
										<ModelPartialReplacementProvider initial={{ "___KategoriiVoprosov": ComponetsReplacement }}>
											<FieldFullReplacementProvider initial={{ "___object": ComponetsReplacement }}>
												<FieldPartialReplacementProvider initial={{ "___CriterionParams": ComponetsReplacement }}>
													{/* <div> */}
														<Routes>
															<Route path="/app/switch/*" element={<RequireAuth><AppSwitch /></RequireAuth>} />
															{/* <Route exact path="/app/" render={() => <Redirect to="/app/common/main/myaccount" />} /> */}
															{/* <Route path="/app/signup" element={<Signup} exact /> */}
															{/* <Route path="/app/login" element={<Login />} exact /> */}
															<Route path="/app/event/:id/myresult" element={<RequireAuth><EventResult /></RequireAuth>} />
															<Route path="/app/event/:id/result-final" element={<RequireAuth><EventResultFinal /></RequireAuth>} />
															<Route path="/app/tg-link" element={<RequireAuth><TgDesktop /></RequireAuth>} />
															<Route path="/app/pay/:id" element={<RequireAuth><Payment /></RequireAuth>} />
															{/* <Route path="/app/promo/:id" element={<RequireAuth><Promo /></RequireAuth>} /> */}
															{/* <Route path="/app/testing" element={<RequireAuth><Testing /></RequireAuth>} /> */}
															<Route path="/app/pay-result/:number" element={<RequireAuth><PaymentResult /></RequireAuth>} />
															{/* <Route path="/app/pay-error/:number" element={<RequireAuth><PaymentError /></RequireAuth>} /> */}
															<Route path="/app/reports/*" element={<RequireAuth><Reports /></RequireAuth>} />
															<Route path="/app/*" element={<RequireAuth><Home /></RequireAuth>} />
														</Routes>
													{/* </div> */}
												</FieldPartialReplacementProvider>
											</FieldFullReplacementProvider>
										</ModelPartialReplacementProvider>
									</ModelFullReplacementProvider>
								</CollectionPartialReplacementProvider>
							</CollectionFullReplacementProvider>
						</LayoutWidthContext.Provider>
					</IsDesktopOrLaptopContext.Provider>
				</IsMobileContext.Provider>
			</ClipboardContext.Provider>
		);
	} else {
		return (
			<IsMobileContext.Provider value={isMobile}>
				<IsDesktopOrLaptopContext.Provider value={isDesktopOrLaptop}>
					<LayoutWidthContext.Provider value={[layoutWidth, setLayoutWidth]}>
						{/* <div> */}
							{/* Мобильный интерфейс */}
							{/* <ConfigProvider locale={ruRU}> */}
							<Routes>
								<Route path="/app/switch/*" element={<RequireAuth><AppSwitch /></RequireAuth>} />
								{/* <Route exact path="/app/" render={() => <Redirect to="/app/common/main/myaccount" />} /> */}
								{/* <Route path="/app/signup" render={() => <Signup {...props} mobile={true} />} exact /> */}
								{/* <Route path="/app/login" element={<Login {...props} mobile={true} />} exact /> */}
								<Route path="/app/tg-link" element={<RequireAuth><TgMobile /></RequireAuth>} />
								{/* <Route path="/app/event/:id/avatar" element={<RequireAuth><EventAvatar /></RequireAuth>} /> */}
								<Route path="/app/event/:id/myresult" element={<RequireAuth><EventResultMobile /></RequireAuth>} />
								<Route path="/app/event/:id/result-final" element={<RequireAuth><EventResultFinalMobile /></RequireAuth>} />
								<Route path="/app/pay/:id" element={<RequireAuth><PaymentMobile /></RequireAuth>} />
								{/* <Route path="/app/promo/:id" element={<RequireAuth><PromoMobile /></RequireAuth>} /> */}
								{/* <Route path="/app/testing" element={<RequireAuth><Testing /></RequireAuth>} /> */}
								<Route path="/app/checkticket/:id" element={<RequireAuth><CheckticketMobile /></RequireAuth>} />
								<Route path="/app/pay-result/:number" element={<RequireAuth><PaymentResultMobile /></RequireAuth>} />
								{/* <Route path="/app/pay-error/:number" element={<RequireAuth><PaymentErrorMobile /></RequireAuth>} /> */}
								<Route path="/app/reports/*" element={<RequireAuth><Reports /></RequireAuth>} />
								<Route path="/app/*" element={<RequireAuth><HomeMobile /></RequireAuth>} />
							</Routes>
							{/* </ConfigProvider> */}
						{/* </div> */}
					</LayoutWidthContext.Provider>
				</IsDesktopOrLaptopContext.Provider>
			</IsMobileContext.Provider>
		);
	}
}

function App(props) {
	React.useEffect(() => {
		window.addEventListener('popstate', function (e) {
			if (e.state && e.state.cb && window.historyCallbackFunctions && window.historyCallbackFunctions[e.state.cb]) {
				window.historyCallbackFunctions[e.state.cb].apply(this, arguments);
			}
		}, false);
	}, []);
	return (
		<AuthProvider>
			{/* <AuthProvider keepAlive="/api/keep-alive"> */}
			<Provider store={store}>
				<BrowserRouter getUserConfirmation={getUserConfirmation}>
					<ConfigProvider>
						<Layout />
					</ConfigProvider>
				</BrowserRouter>
			</Provider>
		</AuthProvider>
	)
}

export default App;